import { registerCashOperation } from './registerCashOperation';
import { Permission } from 'core/api';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';

declare global {
	interface CommandType {
		registerOutputCashOperation: () => Promise<Result>
	}
}

Command.register('registerOutputCashOperation', Preconditions.and(Preconditions.ensure(Permission.Cashdrawer_RegisterOutputCashTransaction), Preconditions.ensureSlaveCanHandleCashOperations), () => registerCashOperation('OUTPUT'));

